<template>
  <div class="n_dialog_header">
    <div class="sec div_before">
      资源分类：
      <el-select
        v-model="categoryId"
        placeholder="请选择"
        size="small"
        style="width: 300px"
        @change="changeCategory"
      >
        <el-option
          v-for="item in resourceDatas"
          :key="item.id"
          :label="item.categoryName"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="sec div_flex">
      <span class="title div_before">
        {{
          from == "question"
            ? "试题选择"
            : from == "testPaper"
            ? "试卷选择"
            : ""
        }}：<span class="num">{{ checkedNum }}</span
        >个
      </span>
      <div>
        <el-select
          v-if="from == 'question' && courseModel != 1"
          v-model="questiontypeId"
          :disabled="isField"
          placeholder="请选择题型"
          size="small"
          style="width: 160px; margin-right: 16px"
          clearable
          @change="searchBtn"
          @clear="searchBtn"
        >
          <el-option
            v-for="item in questiontypeDatas"
            :key="item.id"
            :label="item.questiontypeName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="from == 'question' && courseModel == 1"
          v-model="internaltypeid"
          :disabled="isField"
          placeholder="请选择题型"
          size="small"
          style="width: 160px; margin-right: 16px"
          clearable
          @change="searchBtn"
          @clear="searchBtn"
        >
          <el-option
            v-for="item in questiontypeDatas"
            :key="item.id"
            :label="item.questiontypeName"
            :value="item.internaltypeid"
          >
          </el-option>
        </el-select>
        <el-select
          v-if="from == 'question'"
          v-model="difficulty"
          placeholder="请选择难度"
          size="small"
          style="width: 160px; margin-right: 16px"
          clearable
          @change="searchBtn"
          @clear="searchBtn"
        >
          <el-option
            v-for="item in difficultyData"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>

        <!-- <el-input
          v-model="name"
          placeholder="请输入关键字"
          size="small"
          style="width: 160px; margin-right: 16px"
          clearable
          @clear="searchBtn"
          @keyup.enter.native="searchBtn"
        ></el-input> -->

        <n-search-input
          style="display: inline-block; width: 160px; margin-right: 16px"
          :placeholder="'请输入关键字'"
          v-model="name"
          @searchInput="searchInput"
        ></n-search-input>
        <div class="search_btn" @click="searchBtn">查询</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../../api/newCourseApi.js";
export default {
  name: "n_dialog_header",
  components: {},
  props: {
    from: {
      type: String,
      default: "",
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    courseId: {
      type: [Number, String],
      default: "",
    },
    subjectId: {
      type: [Number, String],
      default: "",
    },
    chooseNum: {
      type: [Number, String],
      default: "",
    },
    isField: { //是否只显示实操题
      type: Boolean,
      default: false,
    },
    isShowOtherTypes: { //除单，多，判，实操
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      checkedNum: 0,
      categoryId: "", //资源分类id
      resourceDatas: [],
      questiontypeId: null,
      internaltypeid: null,
      questiontypeDatas: [],
      difficulty: null,
      difficultyData: [
        { id: 1, label: "简单" },
        { id: 2, label: "中等" },
        { id: 3, label: "困难" },
      ],
      name: "",
      courseModel: this.$route.query.courseModel || '', // 产品模式 1标准 2产品
    };
  },
  created() {},
  mounted() {
    this.findResCategoryByCourseId(
      this.courseId ? this.courseId : this.$route.query.id
    );
    if (this.from == "question") {
      this.findTypeBySubject(
        this.subjectId ? this.subjectId : this.$route.query.subjectId
      );
    }
  },
  watch: {
    dialogVisible: function (val) {
      if (val) {
        this.findResCategoryByCourseId(
          this.courseId ? this.courseId : this.$route.query.id
        );
        if (this.from == "question") {
          this.findTypeBySubject(
            this.subjectId ? this.subjectId : this.$route.query.subjectId
          );
        }
      } else {
        this.emptyData();
      }
    },
    chooseNum: {
      handler: function (val) {
        this.checkedNum = val;
      },
      immediate: true,
    },
  },
  methods: {
    // 查询资源分类
    findResCategoryByCourseId(id) {
      api
        .FindResCategoryByCourseId(id)
        .then((res) => {
          if (res.code == "0") {
            this.resourceDatas = res.data;
            this.categoryId = this.resourceDatas.find(item => item.categoryName === "其它") ? this.resourceDatas.find(item => item.categoryName === "其它").id : ''; // 默认 其它
            this.changeCategory();
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询试题类型
    findTypeBySubject() {
      // 1标准模式 查findTypeByModel
      let apiUrl = this.courseModel != 1 ? api.FindTypeBySubject({subjectId: this.subjectId}) : api.findTypeByModel({typeModel: 1});

        apiUrl.then((res) => {
          if (res.code == "0") {
            this.questiontypeDatas = res.data;
            if(this.isField){
            this.questiontypeDatas.forEach((val)=>{
              if(val.internaltypeid == 9){
                setTimeout(()=>{
                  this.questiontypeId = val.id
                  this.searchBtn()
                },200) 
              }
            })
          }
          
          // 课程编辑/试题，暂时过滤掉 除(单，多，判，实操), 如 不定项6，
          if (!this.isShowOtherTypes) {
            this.questiontypeDatas = this.questiontypeDatas.filter(item => item.internaltypeid !== 6)
          }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchInput(val) {
      this.name = val;
      this.searchBtn();
    },
    searchBtn() {
      let params = {
        questiontypeId: this.questiontypeId,
        internaltypeid: this.internaltypeid,
        difficulty: this.difficulty,
        name: this.name,
      };
      this.$emit("searchFunc", params);
    },
    emptyData() {
      this.categoryId = "";
      this.categoryId = this.resourceDatas.find(item => item.categoryName === "其它") ? this.resourceDatas.find(item => item.categoryName === "其它").id : ''; // 默认 其它
      this.resourceDatas = [];
      this.questiontypeId = "";
      this.internaltypeid = "";
      this.questiontypeDatas = [];
      this.difficulty = "";
      this.name = "";
    },
    changeCategory() {
      this.$emit("changeCategory", this.categoryId);
    },
  },
};
</script>

<style scoped lang="scss">
.n_dialog_header {
  border-bottom: 1px solid #ededf0;
  .sec {
    margin-bottom: 16px;
    font-size: 12px;
    .num {
      color: #1890ff;
    }
  }
  .div_flex {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .search_btn {
      display: inline-block;
      width: 64px;
      height: 32px;
      background: linear-gradient(327deg, #69d5ff 0%, #0084ff 100%);
      border-radius: 6px;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
    }
  }
  .div_before {
    &::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/n_dialog_header.vue